import React from 'react';
import { Location } from '@gatsbyjs/reach-router';

/**
   * Checks for a queryString param
   * @param {*} locationObject
   * @returns true if the param is set
   */
function checkRedirectFalseParam(locationObject) {
  const currentParams = new URLSearchParams(locationObject.search);
  return currentParams.get('redirect') === 'false';
}

function withLocation(ComponentToWrap) {
  // eslint-disable-next-line func-names
  return function (props) {
    return (
      <Location>
        {({ location, navigate }) => {
          const urlSearchParams = new URLSearchParams(location.search);
          const search = Object.fromEntries(urlSearchParams.entries());
          return (
            <ComponentToWrap
              {...props}
              location={location}
              navigate={navigate}
              search={search}
            />
          );
        }}
      </Location>
    );
  };
}

export { checkRedirectFalseParam, withLocation };
